// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page404-page{width:100%}.page404-page .error-404-image{max-width:400px;margin-bottom:35px}.page404-page h1{font-size:28px;font-weight:bold}.page404-page h2{font-size:24px;font-weight:100}.page404-page .action-links{margin-top:70px;margin-bottom:25px}.page404-page .text-link-class{font-size:20px;margin:25px}@media only screen and (max-width: 768px){.error-404-image{padding:30px}}", ""]);
// Exports
module.exports = exports;
